var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    fillRule: "nonzero",
    d: "M25.7321429,10 L6.26785714,10 C6.12002128,10 6,9.85064019 6,9.66666667 L6,8.33333333 C6,8.14935981 6.12002128,8 6.26785714,8 L25.7321429,8 C25.8799787,8 26,8.14935981 26,8.33333333 L26,9.66666667 C26,9.85064019 25.8799787,10 25.7321429,10 Z M15.7484751,17 L6.25152492,17 C6.11270314,17 6,16.8506402 6,16.6666667 L6,15.3333333 C6,15.1493598 6.11270314,15 6.25152492,15 L15.7484751,15 C15.8872969,15 16,15.1493598 16,15.3333333 L16,16.6666667 C16,16.8506402 15.8872969,17 15.7484751,17 Z M25.7321429,24 L6.26785714,24 C6.12002128,24 6,23.8506402 6,23.6666667 L6,22.3333333 C6,22.1493598 6.12002128,22 6.26785714,22 L25.7321429,22 C25.8799787,22 26,22.1493598 26,22.3333333 L26,23.6666667 C26,23.8506402 25.8799787,24 25.7321429,24 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.6321c3c4.svg";
export { ForwardRef as ReactComponent };